<template>
<div class="share-tooltip">
        <a
            target="_blank"
            :href="makeFacebookLink(id, name)"
            class="fb-xfbml-parse-ignore share-tooltip__fb"
            tabindex="0"
            aria-label="Podziel się na Facebooku"
            >
            
        </a>
        <a
            target="_blank"
            :href="makeMailLink(id, name)"
            class="share-tooltip__mail"
            tabindex="0"
            aria-label="Podziel się przez EMail"
            >
            
        </a>
        <a
            target="_blank"
            :href="makeTwitterLink(id, name)"
            class="share-tooltip__twitter"
            tabindex="0"
            aria-label="Podziel się przez Twitter"
            >
            
        </a>
</div>
</template>

<script>
import mixin from '../mixin';

export default {
    props: ['id', 'name', 'first'],
    mixins: [mixin],
}
</script>

<style scoped lang="scss">
    .share-tooltip{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        max-width: 11rem;

        &__fb{
            background-image: url('../partials/fb.png');
            background-position: center;
            background-repeat: no-repeat;
            background-color: #3569a7;
            width: 3rem;
            height: 3rem;
        }

        &__mail{
            background-image: url('../partials/mail.png');
            background-position: center;
            background-repeat: no-repeat;
            background-color: #2c253f;
            width: 3rem;
            height: 3rem;
        }

        &__twitter{
            background-image: url('../partials/twitter.png');
            background-position: center;
            background-repeat: no-repeat;
            background-size: 60%;
            background-color: #21a2f2;
            width: 3rem;
            height: 3rem;
        }
    }
</style>